// extracted by mini-css-extract-plugin
export var externalLink = "_9g-0";
export var internalLinkLabel = "_9g-1";